const showcase = [
	{
		path: '/agency/press-release/generate',
		name: 'agency-press-release-generate',
		component: () => import('@/views/agency/press-release/generate.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/press-release/templates',
		name: 'agency-press-releases-templates',
		component: () => import('@/views/agency/press-release/templates/list.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/press-release/templates/new',
		name: 'agency-press-releases-templates-new',
		component: () => import('@/views/agency/press-release/templates/edit.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/press-release/templates/edit/:id',
		name: 'agency-press-releases-templates-edit',
		component: () => import('@/views/agency/press-release/templates/edit.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/showcases/list',
		name: 'agency-showcases-list',
		component: () => import('@/views/agency/showcases/list.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/showcases/new',
		name: 'agency-showcases-new',
		component: () => import('@/views/agency/showcases/new.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/showcases/edit/:id',
		name: 'agency-showcases-edit',
		component: () => import('@/views/agency/showcases/new.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/showcase-deliverables/list',
		name: 'agency-showcase-deliverables-list',
		component: () => import('@/views/agency/showcase-deliverables/list.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	// Landing point for showcase_deliverable notifications — see
	// src/utils/adminUrlGenerator.js. The bell routes by object+id, and
	// data.id is the submission id.
	{
		path: '/agency/showcase-deliverables/detail/:id',
		name: 'agency-showcase-deliverables-detail',
		component: () => import('@/views/agency/showcase-deliverables/detail.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/showcases-submissions/list',
		name: 'agency-showcases-submissions-list',
		component: () => import('@/views/agency/showcases-submissions/list.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/showcases-submissions/resolution',
		name: 'agency-showcases-submissions-resolution',
		component: () => import('@/views/agency/showcases-submissions/resolution.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/showcases-submissions/new',
		name: 'agency-showcases-submissions-new',
		component: () => import('@/views/agency/showcases-submissions/new.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/showcases-submissions/edit/:id',
		name: 'agency-showcases-submissions-edit',
		component: () => import('@/views/agency/showcases-submissions/new.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/showcases/report/:id',
		name: 'agency-showcases-report',
		component: () => import('@/views/agency/showcases/report.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/showcases/coverage/:id',
		name: 'agency-showcases-coverage',
		component: () => import('@/views/agency/showcases/coverage.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/showcases-coverages/list',
		name: 'agency-showcases-coverages-list',
		component: () => import('@/views/agency/showcases-coverages/list.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/showcases-coverages/new',
		name: 'agency-showcases-coverages-new',
		component: () => import('@/views/agency/showcases-coverages/new.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/showcases-coverages/edit/:id',
		name: 'agency-showcases-coverages-edit',
		component: () => import('@/views/agency/showcases-coverages/new.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/journalists/list',
		name: 'agency-journalists-list',
		component: () => import('@/views/agency/journalists/list.vue'),
		meta: { layout: 'content' },
	},
	{
		path: '/agency/journalist-import',
		name: 'agency-journalist-import',
		component: () => import('@/views/agency/journalist-import/index.vue'),
		meta: { layout: 'content' },
	},
	{
		path: '/agency/coverage-source-types/list',
		name: 'agency-coverage-source-types-list',
		component: () => import('@/views/agency/coverage-source-types/list.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/coverage-feed-sources/list',
		name: 'agency-coverage-feed-sources-list',
		component: () => import('@/views/agency/coverage-feed-sources/list.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},

	// Showcase Media Partner Applications
	{
		path: '/agency/showcase-media-partner-applications/list',
		name: 'agency-showcase-media-partner-applications-list',
		component: () => import('@/views/agency/showcase-media-partner-applications/list.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/showcase-media-partner-applications/detail/:id',
		name: 'agency-showcase-media-partner-applications-detail',
		component: () => import('@/views/agency/showcase-media-partner-applications/detail.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},

	// Showcase Coverage Submissions
	{
		path: '/agency/showcase-coverage-submissions/list',
		name: 'agency-showcase-coverage-submissions-list',
		component: () => import('@/views/agency/showcase-coverage-submissions/list.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},

	// Showcase Coverage Suggestions
	{
		path: '/agency/showcase-coverage-suggestions/list',
		name: 'agency-showcase-coverage-suggestions-list',
		component: () => import('@/views/agency/showcase-coverage-suggestions/list.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},

	// Bulk Coverage Import
	{
		path: '/agency/showcases-coverages/bulk-import',
		name: 'agency-showcases-coverages-bulk-import',
		component: () => import('@/views/agency/showcases-coverages/bulk-import.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},

	// Showcase Sponsor Applications
	{
		path: '/agency/showcase-sponsor-applications/list',
		name: 'agency-showcase-sponsor-applications-list',
		component: () => import('@/views/agency/showcase-sponsor-applications/list.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/showcase-sponsor-applications/detail/:id',
		name: 'agency-showcase-sponsor-applications-detail',
		component: () => import('@/views/agency/showcase-sponsor-applications/detail.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},

	// Studio Prospects (Steam upcoming games — not Showcase-scoped, general studio outreach)
	{
		path: '/agency/studio-prospects/list',
		name: 'agency-studio-prospects-list',
		component: () => import('@/views/agency/studio-prospects/list.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/studio-prospects/board',
		name: 'agency-studio-prospects-board',
		component: () => import('@/views/agency/studio-prospects/board.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/studio-prospects/review',
		name: 'agency-studio-prospects-review',
		component: () => import('@/views/agency/studio-prospects/review.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/studio-prospects/source-reviews',
		name: 'agency-studio-prospect-source-reviews',
		component: () => import('@/views/agency/studio-prospects/source-reviews.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/commercial-account-opportunities',
		name: 'agency-commercial-account-opportunities',
		component: () => import('@/views/agency/studio-prospects/commercial-accounts.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	// `/all` rather than the bare `/agency/commercial-accounts`: the sidebar
	// marks an entry active by path prefix, so a parent path would light up
	// alongside /worklist and /conversion and leave two items highlighted at
	// once. With three sibling paths, exactly one can ever match.
	{
		path: '/agency/commercial-accounts',
		redirect: { name: 'agency-commercial-accounts-list' },
	},
	{
		path: '/agency/commercial-accounts/all',
		name: 'agency-commercial-accounts-list',
		component: () => import('@/views/agency/commercial-accounts/list.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/commercial-accounts/worklist',
		name: 'agency-commercial-accounts-worklist',
		component: () => import('@/views/agency/commercial-accounts/worklist.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/commercial-accounts/board',
		name: 'agency-commercial-accounts-board',
		component: () => import('@/views/agency/commercial-accounts/board.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/commercial-accounts/conversion',
		name: 'agency-commercial-accounts-conversion',
		component: () => import('@/views/agency/commercial-accounts/conversion.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},

	// Prospect Email Templates
	{
		path: '/agency/prospect-email-templates',
		name: 'agency-prospect-email-templates-list',
		component: () => import('@/views/agency/prospect-email-templates/list.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/prospect-email-templates/new',
		name: 'agency-prospect-email-templates-new',
		component: () => import('@/views/agency/prospect-email-templates/edit.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
	{
		path: '/agency/prospect-email-templates/edit/:id',
		name: 'agency-prospect-email-templates-edit',
		component: () => import('@/views/agency/prospect-email-templates/edit.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},

	// Press Room Key Requests
	{
		path: '/agency/press-room-key-requests/list',
		name: 'agency-press-room-key-requests-list',
		component: () => import('@/views/agency/press-room-key-requests/list.vue'),
		meta: { layout: 'content', module: 'MGAG,showcases' },
	},
]

export default showcase
